import logo from "./logo.svg";
import "./css/app.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import BaseLayout from "./components/layouts/BaseLayout";
import { useEffect } from "react";
import DashboardLayout from "./components/layouts/DashboardLayout.jsx";
import Login from "./components/pages/Login.jsx";
import AddUser from "./components/pages/users/AddUser.jsx";
import EditUser from "./components/pages/users/EditUser.jsx";
import UsersLayout from "./components/layouts/UsersLayout.jsx";
import CSVUploader from "./components/utils/CsvUploader.jsx";
import SchoolsLayout from "./components/layouts/SchoolsLayout.jsx";
import TeacherLayout from "./components/layouts/TeachersLayout.jsx";
import AddTeacher from "./components/pages/teachers/AddTeacher.jsx";
import EditTeacher from "./components/pages/teachers/EditTeacher.jsx";
import ClassesLayout from "./components/layouts/ClassesLayout.jsx";
import StudentsLayout from "./components/layouts/StudentsLayout.jsx";
import AddStudent from "./components/pages/students/AddStudent.jsx";
import AddCulturalPlace from "./components/pages/culturalPlaces/AddCulturalPlace.jsx";
import EditCulturalPlace from "./components/pages/culturalPlaces/EditCulturalPlace.jsx";
import CulturalPlacesLayout from "./components/layouts/CulturalPlacesLayout.jsx";
import EventsLayout from "./components/layouts/EventsLayout.jsx";
import AddEvent from "./components/pages/events/AddEvent.jsx";
import EditEvent from "./components/pages/events/EditEvent.jsx";
import AddChallenge from "./components/pages/challenges/AddChallenge.jsx";
import AddClass from "./components/pages/classes/AddClass.jsx";
import EditClass from "./components/pages/classes/EditClass.jsx";
import EditStudent from "./components/pages/students/EditStudent.jsx";
import DetailTeacher from "./components/pages/teachers/DetailTeacher.jsx";
import DetailClass from "./components/pages/classes/DetailClass.jsx";
import DetailStudent from "./components/pages/students/DetailStudent.jsx";
import ResetPassword from "./components/utils/ResetPassword.jsx";
import ProfileLayout from "./components/layouts/ProfileLayout.jsx";
import ChallengesLayout from "./components/layouts/ChallengesLayout.jsx";
import ManageSelfies from "./components/pages/points/ManageSelfies.jsx";
import ManageSearches from "./components/pages/points/ManageSearches.jsx";
import ManageChat from "./components/pages/points/ManageChat.jsx";
import EditChallenge from "./components/pages/challenges/EditChallenge.jsx";
import ValidateEmail from "./components/utils/ValidateEmail.jsx";
import DetailChallenge from "./components/pages/challenges/DetailChallenge.jsx";

function App() {
  const isLoggedIn = localStorage.getItem("token");

  return (
    <Router>
      <Routes>
        <Route
          path="/users"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            index
            element={
              <BaseLayout>
                <UsersLayout />
              </BaseLayout>
            }
          />
          <Route
            path="add"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <AddUser />
                </BaseLayout>
              )
            }
          />
          <Route
            path="edit/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <EditUser />
                </BaseLayout>
              )
            }
          />
        </Route>
        <Route
          path="/"
          element={
            !isLoggedIn ? (
              <Navigate to="/login" />
            ) : (
              <BaseLayout>
                <DashboardLayout />
              </BaseLayout>
            )
          }
        />
        <Route
          path="/schools"
          element={
            !isLoggedIn ? (
              <Navigate to="/login" />
            ) : (
              <BaseLayout>
                <SchoolsLayout />
              </BaseLayout>
            )
          }
        />
        <Route
          path="/teachers"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            index
            element={
              <BaseLayout>
                <TeacherLayout />
              </BaseLayout>
            }
          />
          <Route
            path="add"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <AddTeacher />
                </BaseLayout>
              )
            }
          />
          <Route
            path="edit/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <EditTeacher />
                </BaseLayout>
              )
            }
          />
          <Route
            path="detail/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <DetailTeacher />
                </BaseLayout>
              )
            }
          />
        </Route>
        <Route
          path="/classes/:id?"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            index
            element={
              <BaseLayout>
                <ClassesLayout />
              </BaseLayout>
            }
          />
          <Route
            path="add/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <AddClass />
                </BaseLayout>
              )
            }
          />
          <Route
            path="edit/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <EditClass />
                </BaseLayout>
              )
            }
          />
          <Route
            path="detail/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <DetailClass />
                </BaseLayout>
              )
            }
          />
        </Route>
        <Route
          path="/students"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            index
            element={
              <BaseLayout>
                <StudentsLayout />
              </BaseLayout>
            }
          />
          <Route
            path="add"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <AddStudent />
                </BaseLayout>
              )
            }
          />
          <Route
            path="edit/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <EditStudent />
                </BaseLayout>
              )
            }
          />
          <Route
            path="detail/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <DetailStudent />
                </BaseLayout>
              )
            }
          />
        </Route>
        <Route
          path="/culturalPlaces"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            index
            element={
              <BaseLayout>
                <CulturalPlacesLayout />
              </BaseLayout>
            }
          />
          <Route
            path="add"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <AddCulturalPlace />
                </BaseLayout>
              )
            }
          />
          <Route
            path="edit/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <EditCulturalPlace />
                </BaseLayout>
              )
            }
          />
        </Route>
        <Route
          path="/events"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            index
            element={
              <BaseLayout>
                <EventsLayout />
              </BaseLayout>
            }
          />
          <Route
            path="add"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <AddEvent />
                </BaseLayout>
              )
            }
          />
          <Route
            path="edit/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <EditEvent />
                </BaseLayout>
              )
            }
          />
        </Route>
        <Route
          path="/challenges"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            index
            element={
              <BaseLayout>
                <ChallengesLayout />
              </BaseLayout>
            }
          />
          <Route
            path="add"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <AddChallenge />
                </BaseLayout>
              )
            }
          />
          <Route
            path="edit/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <EditChallenge />
                </BaseLayout>
              )
            }
          />
          <Route
            path="detail/:id"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <DetailChallenge />
                </BaseLayout>
              )
            }
          />
        </Route>
        <Route
          path="/points"
          element={isLoggedIn ? "" : <Navigate to="/login" />}
        >
          <Route
            path="selfie"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <ManageSelfies />
                </BaseLayout>
              )
            }
          />
          <Route
            path="search"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <ManageSearches />
                </BaseLayout>
              )
            }
          />
          <Route
            path="chat"
            element={
              !isLoggedIn ? (
                <Navigate to="/login" />
              ) : (
                <BaseLayout>
                  <ManageChat />
                </BaseLayout>
              )
            }
          />
        </Route>

        <Route
          path="/profile"
          element={
            !isLoggedIn ? (
              <Navigate to="/login" />
            ) : (
              <BaseLayout>
                <ProfileLayout />
              </BaseLayout>
            )
          }
        />

        <Route
          path="/csvupload"
          element={
            !isLoggedIn ? (
              <Navigate to="/login" />
            ) : (
              <BaseLayout>
                <CSVUploader />
              </BaseLayout>
            )
          }
        />

        <Route
          path="/login/:role?"
          element={isLoggedIn ? <Navigate to="/" /> : <Login />}
        />
        <Route path="/resetPassword/:token" element={<ResetPassword />} />
        <Route path="/validateEmail/:token" element={<ValidateEmail />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
